module.exports = __webpack_public_path__ + "static/media/humble.ae93ef2f.png";